// generated by the plop
import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { EquipmentModel } from '../../symbols';

export interface EquipmentsStateModel {
  equipmentList: PaginatorModel<EquipmentModel>;
  equipmentAutoCompleteList: PaginatorModel<EquipmentModel>;
  loadEquipmentListStatus: PROGRESS_STATUSES;
}

export const EQUIPMENTS_STATE_DEFAULT: EquipmentsStateModel = {
  equipmentList: {
    data: [],
    links: null,
    meta: null
  },
  equipmentAutoCompleteList: {
    data: [],
    links: null,
    meta: null
  },
  loadEquipmentListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
